module.exports = __webpack_public_path__ + "img/AITranslate-active.6b995254.png";